<template>
    <div>
        <el-button type="primary" @click="submit()">立即发布</el-button>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {

            };
        },
        created() {

        },
        mounted() {
            // 在组件被挂载之后调用。
        },
        methods: {
            async submit() {

            }
        },
        computed: {
            // 计算属性
        },
        watch: {

        },
    };
</script>